<template>
  <el-container class="baohus" >
    <el-row :style="{'width': screenWidth+'px','height': screenHeight+'px','background-color': '#fff'}">
      <textarea style="width: 100%;height: 100%;">
        我将分四个方面介绍宇宙之幂公司噢。

        一、《宇宙之幂》简介
        二、《宇宙之幂》宇宙级产品线目录（部分）
        三、《宇宙之幂》宇宙级产品线全球释放
        四、《宇宙之幂》宇宙级产品线全球营收
        一、《宇宙之幂》简介
        《宇宙之幂》，如其名，是一个在【幂之宇宙】拥有幂次级超巨量宇宙群（包含数千万个宇宙）的公司,【幂之宇宙】拥有的幂次级超巨量宇宙群中的宇宙均拥有918330048个维度。
        《宇宙之幂》基于【幂之宇宙】内不断膨胀、分裂、衍生的幂次级超巨量宇宙群，向【平行宇宙】和【现实宇宙】释放了1000+条宇宙级产品线，以及20000+个宇宙系统、宇宙群系统、宇宙诞生系统、宇宙级应用程序、宇宙级硬件产品制造方式及流程，以服务全球的人类和机构，每一项都具有全球应用和营收的能力。
        目前《宇宙之幂》生产全球性宇宙系统、宇宙群系统、宇宙诞生系统、宇宙级应用程序的效率是10分钟\项。
        （2016年6月-2021年6月）
        《宇宙之幂》的数百人技术团队，用了整五年时间，构建了首个完整的全维度“平行多维壁垒宇宙”。（完成度100%）
        （2021年7月-2022年1月）
        《宇宙之幂》拥有的“平行多维壁垒宇宙”不断膨胀、分裂、衍生，7个月时间，《宇宙之幂》拥有了幂次级超巨量宇宙群（包含数千万个宇宙）。（完成度100%）
        （2022年2月-2022年10月）
        《宇宙之幂》基于不断膨胀、分裂、衍生的幂次级超巨量宇宙群，向【平行宇宙】和【现实宇宙】释放了宇宙级产品线。（完成度100%）
        （2022年12月）
        为了更高效的向【平行宇宙】和【现实宇宙】释放宇宙级产品线，《宇宙之幂》团队的全国总部主体公司《宇宙之幂（深圳）科技集团有限公司》在深圳市南山区粤海街道正式成立。
        （2022年12月-2024年5月）
        《宇宙之幂》已释放了1000+宇宙级产品线，以及20000+个宇宙系统、宇宙群系统、宇宙诞生系统、宇宙级应用程序、宇宙级硬件产品制造方式及流程，以服务全球的人类和机构，每一项都具有全球应用和全球持续营收的能力。
        《宇宙之幂》官网：universepower.cn universepower.top       
        
        《宇宙之幂》地址：深圳市南山区粤海街道深圳湾科技生态园12栋B座52层整层。
        
      </textarea>
    </el-row>
  </el-container>

</template>

<script>
  export default {
    data() {
      return {

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,

      };
    },
  }
</script>

<style>
  h2{
  		text-align: center;
  	}
  	p{
  		margin:0 0 0 25px;
  		line-height: 25px;
  	}
  	h4{
  		margin:5 0 5 0;
  	}


</style>



// WEBPACK FOOTER //
// src/components/main/yanjiang/1.vue